import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import userReducer from "./userSlice"
import filtroLiquidacionesReducer from "./filtroLiquidacionesSlice"
import resultadoGrillaFacturaJuicio from './resultadoGrillaFacturaJuicioSlice'
import resultadoGrillaPagosSinFactura from './resultadoGrillaPagosSinFacturaSlice'
import resultadoGrillaFactura from './resultadoGrillaFacturaSlice'
import resultadoGrillaObservaciones from './resultadoGrillaObservacionesSlice'
import resultadoGrillaJuicios from './resultadoGrillaJuicioSlice'
import filtroFacturasReducer from './filtroFacturasSlice'
import filtroPagosSinFacturaReducer from './filtroPagosSinFacturaSlice'
import filtroObservacionesReducer from './filtroObservacionesSlice'
import filtroJuiciosReducer from './filtroJuiciosSlice'
import facturaSlice from "./facturaSlice"
import pagoSinFacturaReducer from "./datosPagoSinFacturaSlice"
import observacionSlice from "./observacionSlice"
import juicioSlice from "./juicioSlice"

const rootReducer = combineReducers({
  usuario: userReducer,
  filtrosLiquidaciones: filtroLiquidacionesReducer,
  resultadoGrillaFacturaJuicio: resultadoGrillaFacturaJuicio,
  resultadoGrillaPagosSinFactura: resultadoGrillaPagosSinFactura,
  resultadoGrillaFactura: resultadoGrillaFactura,
  resultadoGrillaJuicios: resultadoGrillaJuicios,
  resultadoGrillaObservaciones: resultadoGrillaObservaciones,
  filtrosFacturas: filtroFacturasReducer,
  filtrosPagosSinFactura: filtroPagosSinFacturaReducer,
  filtrosObservaciones: filtroObservacionesReducer,
  filtrosJuicios: filtroJuiciosReducer,
  datosFactura: facturaSlice,
  datosPagoSinFactura: pagoSinFacturaReducer,
  datosObservacion: observacionSlice,
  datosJuicio: juicioSlice
});

export const store = configureStore({
  reducer: {
    rootReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
